import { gql } from '@apollo/client';
import Fragments from './fragments';

export const DICTIONARY_CHANGED = gql`
  subscription dictionaryChanged {
    dictionaryChanged {
      ...genericDictionaryItem
    }
  }
  ${Fragments.dictionaryItem}
  ${Fragments.genericDictionaryItem}
`;
